import { SendSms } from '@features/Contractor/SendSms'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

export const Route = createFileRoute('/contractor/$contractorId/sendSMS/')({
  component: SendSms,
  staticData: {
    breadcrumb: t('contractor.profile.sendSMS.sendSMS'),
  },
})
